import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function BulkCreationActionsService(token,data) {
    console.log(CURRENT_API_URL);
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/bulkCreationActions`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("Notification create successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while creating notifications . please try again later.");
        return false;
    });
}

export default BulkCreationActionsService;